import { ThreadPostModel } from '@admin/shared/models/comment-models/thread-post-model';

export class CustomerListItemModel {
  fromObject(object: any): CustomerListItemModel {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public customerId: number;
  public customerStatusId: number;
  public customerName: string;
  public customerTaxCode: string;
  public customerVatStatusName: string;

  public accountManagerName: string;

  public totalInvoiceAmount: number;
  public totalPaymentAmount: number;
  public currentDebt: number;
  public oldtDebt: number;
  public totalDebt: number;

  public lastAccComment: ThreadPostModel;
  public lastSalesAccComment: ThreadPostModel;
  public lastDebtComment: ThreadPostModel;
}
